<template>
  	<FreeSignupPinsReports />
</template>

<script>

// @ is an alias to /src
import FreeSignupPinsReports from "@/components/FreeSignupPinsReport.vue";

export default {
  name: "FreeSignupPinsReport",
  components: {
    FreeSignupPinsReports,
  },
};
</script>
